import { toast } from 'react-toastify';
import type { ReactNode } from 'react';
import GreenCheckIcon from '@/assets/icons/GreenCheckIcon.svg?react';
import ColoredWarningIcon from '@/assets/icons/ColoredWarning.svg?react';
import PartyIcon from '@/assets/icons/PartyIcon.svg?react';

type ToastType = 'default' | 'success' | 'warning' | 'congratulations';

export const useToast = () => {
  const showToast = (type: ToastType, text: string | ReactNode) => {
    toast.dismiss();

    switch (type) {
      case 'success':
        toast(
          <div className="flex items-center gap-2">
            <GreenCheckIcon />
            <span>{text}</span>
          </div>,
        );
        return;
      case 'warning':
        toast(
          <div className="flex items-center gap-2">
            <ColoredWarningIcon />
            <span>{text}</span>
          </div>,
        );
        return;
      case 'congratulations':
        toast(
          <div className="flex items-center gap-2">
            <PartyIcon />
            <span>{text}</span>
          </div>,
        );
        return;
      default:
        toast(text);
        return;
    }
  };

  return { showToast };
};
